import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
const LayersIcon = function({
  size = 16,
  title = "LayersIcon",
  ...props
}) {
  const _id = useUniqueInlineId();
  return /* @__PURE__ */ React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "pds-icon",
    title,
    ...props
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: `url(#${_id})`
  }, /* @__PURE__ */ React.createElement("path", {
    d: "m8 1.333.28-.559a.625.625 0 0 0-.56 0l.28.56ZM1.333 4.667l-.28-.56a.625.625 0 0 0 0 1.119l.28-.56ZM8 8l-.28.559a.625.625 0 0 0 .56 0L8 8Zm6.667-3.333.28.559a.625.625 0 0 0 0-1.118l-.28.559ZM1.613 10.774a.625.625 0 0 0-.56 1.118l.56-1.118ZM8 14.667l-.28.559a.625.625 0 0 0 .56 0l-.28-.56Zm6.946-2.775a.625.625 0 1 0-.559-1.118l.56 1.118ZM1.613 7.441a.625.625 0 1 0-.56 1.118l.56-1.118ZM8 11.333l-.28.56a.625.625 0 0 0 .56 0l-.28-.56Zm6.946-2.774a.625.625 0 0 0-.559-1.118l.56 1.118ZM7.72.774 1.054 4.108l.559 1.118 6.666-3.334L7.72.774ZM1.054 5.226 7.72 8.559l.56-1.118-6.667-3.333-.56 1.118Zm7.225 3.333 6.667-3.333-.559-1.118L7.72 7.44l.56 1.118Zm6.667-4.451L8.28.774 7.72 1.892l6.667 3.334.56-1.118ZM1.054 11.892l6.666 3.334.56-1.118-6.667-3.334-.56 1.118Zm7.225 3.334 6.667-3.334-.559-1.118-6.667 3.334.56 1.118ZM1.054 8.559l6.666 3.333.56-1.118-6.667-3.333-.56 1.118Zm7.225 3.333 6.667-3.333-.559-1.118-6.667 3.333.56 1.118Z",
    fill: "currentColor"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: _id
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
};
export default LayersIcon;
